(function () {
  // Event listener cleanup infrastructure
  let cleanupListeners = [];

  function cleanupAllListeners() {
    cleanupListeners.forEach(function (cleanup) {
      try {
        cleanup();
      } catch (e) {
        console.warn('Error during cleanup:', e);
      }
    });
    cleanupListeners = [];
  }

  // Register cleanup on page unload
  window.addEventListener('pagehide', cleanupAllListeners);
  window.addEventListener('beforeunload', cleanupAllListeners);

  // Cache currency formatters for performance
  const currencyFormatters = {};

  function getCachedFormatter(currencyCode, options) {
    const key = currencyCode + JSON.stringify(options);
    if (!currencyFormatters[key]) {
      try {
        currencyFormatters[key] = new Intl.NumberFormat(undefined, Object.assign({}, {
          style: 'currency',
          currency: currencyCode
        }, options));
      } catch (e) {
        // Fallback formatter if currency is invalid
        currencyFormatters[key] = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: 'USD'
        });
      }
    }
    return currencyFormatters[key];
  }

  function formatMoney(cents, currencyCode, options) {
    const amount = Number(cents || 0) / 100;
    const code = currencyCode || 'USD';
    try {
      return getCachedFormatter(code, options).format(amount);
    } catch (err) {
      return '$' + amount.toFixed(2);
    }
  }

  const normalizeRedirectingLinks = function () {
    const replacements = {
      '/collections/herbal-tea': '/collections/organic-blends',
      '/collections/health-blends': '/collections/organic-blends',
      '/collections/herbal-powders': '/collections/pure-powders',
      '/collections/rice': '/collections/organic-rice',
      '/products/moringa-blend': '/products/5n1-power-shot',
      '/products/soursop-blend': '/products/5n1-power-shot',
      '/products/salabat-blend': '/products/ginger-tea-powder-blend',
      '/products/tumeric-tea-powder-blend': '/products/turmeric-tea-powder-blend',
      '/products/turmeric-herbal-tea': '/products/5-in-1-turmeric-tea-powder',
      '/products/agriko-5n1-turmeric-tea': '/products/5-in-1-turmeric-tea-powder',
      '/products/raw-honey': '/products/organic-pure-honey',
      '/products/roasted-black-rice': '/products/philippines-organic-black-rice',
      '/products/cacao-with-5n1-turmeric-blend': '/products/cacao-with-5n1-with-turmeric-blend',
      '/collections/all': '/collections/shop-all',
      '/pages/our-story': '/pages/about',
      '/collections/frontpage': '/collections/shop-all',
      '/blogs/news/storing-rice-freshness': '/blogs/news/how-to-store-rice',
      '/blogs/news/ginger-digestive-health': '/blogs/news/ginger-for-digestive-health',
      '/blogs/news/moringa-superfood-guide': '/blogs/news/moringa-complete-nutrition-guide',
      '/blogs/news/organic-rice-philippines': '/blogs/news/organic-rice-philippines-benefits-varieties-complete-nutrition-guide',
      '/blogs/news/rice-nutrition-breakdown-legacy-reference-guide': '/blogs/news/rice-nutrition-breakdown'
    };

    document.querySelectorAll('a[href]').forEach(function (link) {
      const rawHref = link.getAttribute('href');
      if (!rawHref) return;

      if (rawHref === 'https://m.me/AgrikoPH') {
        link.setAttribute('href', 'https://www.facebook.com/AgrikoPH');
        return;
      }

      let parsedUrl;
      try {
        parsedUrl = new URL(rawHref, window.location.origin);
      } catch (error) {
        return;
      }

      const replacementPath = replacements[parsedUrl.pathname];
      if (!replacementPath) return;

      parsedUrl.pathname = replacementPath;
      parsedUrl.search = '';
      parsedUrl.hash = '';

      if (parsedUrl.origin === window.location.origin) {
        link.setAttribute('href', parsedUrl.pathname);
      } else {
        link.setAttribute('href', parsedUrl.toString());
      }
    });
  };

  const initMotionPreference = function () {
    const root = document.documentElement;
    if (!root) return;

    const reduceFromTheme = root.getAttribute('data-ag-reduce-motion') === 'true';
    let mediaQuery = null;
    if (typeof window.matchMedia === 'function') {
      mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    }

    const applyMotionPreference = function () {
      const reduceFromSystem = mediaQuery ? mediaQuery.matches : false;
      const shouldReduce = reduceFromTheme || reduceFromSystem;
      root.setAttribute('data-ag-reduced-motion', shouldReduce ? 'true' : 'false');
    };

    applyMotionPreference();

    if (!mediaQuery) return;
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', applyMotionPreference);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(applyMotionPreference);
    }
  };
  const initHeaderHeightVar = function () {
    const root = document.documentElement;
    const headerWrap = document.querySelector('.ag-site-frame__header') || document.querySelector('.ag-header-wrap');
    if (!root || !headerWrap) return;

    const applyHeaderHeight = function () {
      const headerHeight = headerWrap.getBoundingClientRect().height;
      if (!headerHeight) return;
      root.style.setProperty('--ag-header-height', Math.round(headerHeight) + 'px');
    };

    applyHeaderHeight();

    if (typeof ResizeObserver === 'function') {
      const observer = new ResizeObserver(applyHeaderHeight);
      observer.observe(headerWrap);
      cleanupListeners.push(function () {
        observer.disconnect();
      });
    }

    window.addEventListener('resize', applyHeaderHeight, { passive: true });
    cleanupListeners.push(function () {
      window.removeEventListener('resize', applyHeaderHeight);
    });
  };

  const initVariantPicker = function () {
    const variantsNode = document.querySelector('[data-product-variants]');
    if (!variantsNode) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent || '[]');
    } catch (err) {
      console.warn('Failed to parse product variants:', err);
      return;
    }

    const form = document.querySelector('.ag-product__form');
    if (!form) return;
    const productRoot = form.closest('.ag-product') || document;

    const optionSelects = Array.prototype.slice.call(form.querySelectorAll('[data-option-select]'));
    const optionPills = Array.prototype.slice.call(form.querySelectorAll('[data-option-pill]'));
    const variantInput = form.querySelector('[data-variant-id]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const priceNode = productRoot.querySelector('[data-product-price]');
    let comparePriceNode = productRoot.querySelector('[data-product-price-compare]');
    const currentPriceNode = productRoot.querySelector('[data-product-price-current]');
    const priceVariantNode = productRoot.querySelector('[data-product-price-variant]');
    const productStatus = form.querySelector('[data-product-status]');
    const stockChip = productRoot.querySelector('[data-product-stock-chip]');
    const soldOutNote = productRoot.querySelector('[data-product-sold-out-note]');
    const lowStockNode = productRoot.querySelector('[data-product-low-stock]');
    const productImage = productRoot.querySelector('[data-product-image]');
    const mediaThumbs = Array.prototype.slice.call(productRoot.querySelectorAll('[data-product-thumb]'));
    const mediaPrevButton = productRoot.querySelector('[data-product-media-prev]');
    const mediaNextButton = productRoot.querySelector('[data-product-media-next]');
    const mediaCurrentNode = productRoot.querySelector('[data-product-media-current]');
    const qtyInput = form.querySelector('[data-qty-input]');
    const qtyDecreaseButton = form.querySelector('[data-qty-decrease]');
    const qtyIncreaseButton = form.querySelector('[data-qty-increase]');
    const lowStockThreshold = Number(form.getAttribute('data-low-stock-threshold') || 0);

    const variantCurrency = (priceNode && priceNode.getAttribute('data-currency-code')) || 'USD';
    const formatVariantMoney = function (cents) {
      return formatMoney(cents, variantCurrency);
    };

    const normalizeUrl = function (url) {
      return String(url || '').replace(/^https?:/, '').split('?')[0];
    };

    const filenameFromUrl = function (url) {
      const normalized = normalizeUrl(url);
      if (!normalized) return '';
      const parts = normalized.split('/');
      return parts[parts.length - 1] || '';
    };

    const sanitizeQuantity = function (value) {
      const parsed = parseInt(value, 10);
      if (Number.isNaN(parsed) || parsed < 1) return 1;
      if (parsed > 99) return 99;
      return parsed;
    };

    const updateQuantityButtons = function () {
      if (!qtyInput) return;
      const quantity = sanitizeQuantity(qtyInput.value);
      qtyInput.value = String(quantity);
      const controlsDisabled = qtyInput.disabled;
      if (qtyDecreaseButton) {
        qtyDecreaseButton.disabled = controlsDisabled || quantity <= 1;
      }
      if (qtyIncreaseButton) {
        qtyIncreaseButton.disabled = controlsDisabled || quantity >= 99;
      }
    };

    const setQuantityEnabled = function (enabled) {
      if (qtyInput) {
        qtyInput.disabled = !enabled;
      }
      updateQuantityButtons();
    };
    const getThumbByMediaId = function (mediaId) {
      if (!mediaId) return null;
      const stringId = String(mediaId);
      for (let i = 0; i < mediaThumbs.length; i += 1) {
        const thumb = mediaThumbs[i];
        if (String(thumb.getAttribute('data-media-id')) === stringId) {
          return thumb;
        }
      }
      return null;
    };

    const getThumbByImageSrc = function (src) {
      const targetFile = filenameFromUrl(src);
      if (!targetFile) return null;

      for (let i = 0; i < mediaThumbs.length; i += 1) {
        const thumb = mediaThumbs[i];
        const thumbSrc = thumb.getAttribute('data-media-src') || '';
        if (filenameFromUrl(thumbSrc) === targetFile) {
          return thumb;
        }
      }
      return null;
    };

    const setMediaCurrent = function (thumb) {
      if (!mediaCurrentNode || !thumb) return;
      const position = thumb.getAttribute('data-media-position') || '1';
      mediaCurrentNode.textContent = position;
    };

    const activateThumb = function (thumb) {
      if (!thumb) return;

      mediaThumbs.forEach(function (item) {
        const isActive = item === thumb;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      setMediaCurrent(thumb);
    };

    const setImageFromThumb = function (thumb) {
      if (!productImage || !thumb) return;

      const thumbSrc = thumb.getAttribute('data-media-src');
      const thumbAlt = thumb.getAttribute('data-media-alt');
      const mediaId = thumb.getAttribute('data-media-id');

      if (thumbSrc && normalizeUrl(thumbSrc) !== normalizeUrl(productImage.getAttribute('src'))) {
        productImage.setAttribute('src', thumbSrc);
        productImage.removeAttribute('srcset');
      }
      if (thumbAlt) {
        productImage.setAttribute('alt', thumbAlt);
      }
      if (mediaId) {
        productImage.setAttribute('data-media-id', mediaId);
      }
    };

    const activateMediaByThumb = function (thumb) {
      if (!thumb) return;
      setImageFromThumb(thumb);
      activateThumb(thumb);
    };

    const getActiveThumbIndex = function () {
      for (let i = 0; i < mediaThumbs.length; i += 1) {
        if (mediaThumbs[i].classList.contains('is-active')) {
          return i;
        }
      }
      return 0;
    };

    const activateMediaByIndex = function (index) {
      if (!mediaThumbs.length) return;
      let safeIndex = index;
      if (safeIndex < 0) safeIndex = mediaThumbs.length - 1;
      if (safeIndex >= mediaThumbs.length) safeIndex = 0;
      activateMediaByThumb(mediaThumbs[safeIndex]);
    };

    const setStockState = function (variant) {
      if (!stockChip) return;

      const inStockLabel = stockChip.getAttribute('data-in-stock-label') || 'In stock';
      const soldOutLabel = stockChip.getAttribute('data-sold-out-label') || 'Sold out';
      const unavailableLabel = stockChip.getAttribute('data-unavailable-label') || 'Unavailable';

      stockChip.classList.remove('is-sold-out', 'is-unavailable');

      if (!variant) {
        stockChip.textContent = unavailableLabel;
        stockChip.classList.add('is-sold-out', 'is-unavailable');
        return;
      }

      if (variant.available) {
        stockChip.textContent = inStockLabel;
      } else {
        stockChip.textContent = soldOutLabel;
        stockChip.classList.add('is-sold-out');
      }
    };

    const setSoldOutState = function (variant) {
      if (!soldOutNote) return;
      soldOutNote.hidden = !(variant && !variant.available);
    };

    const setLowStockState = function (variant) {
      if (!lowStockNode) return;

      const quantity = Number(variant && variant.inventory_quantity);
      const shouldShow = Boolean(
        variant &&
        variant.available &&
        variant.inventory_management &&
        variant.inventory_policy === 'deny' &&
        quantity > 0 &&
        quantity <= lowStockThreshold
      );

      lowStockNode.hidden = !shouldShow;
      if (shouldShow) {
        lowStockNode.textContent = 'Only ' + quantity + ' left in stock.';
      }
    };

    const setButtonState = function (variant) {
      if (!addButton) return;

      const defaultLabel = addButton.getAttribute('data-default-label') || 'Add to cart';
      const soldOutLabel = addButton.getAttribute('data-sold-out-label') || 'Sold out';
      const unavailableLabel = addButton.getAttribute('data-unavailable-label') || 'Unavailable';

      if (!variant) {
        addButton.setAttribute('disabled', 'disabled');
        addButton.classList.add('is-disabled');
        addButton.setAttribute('aria-disabled', 'true');
        addButton.textContent = unavailableLabel;
        if (productStatus) {
          productStatus.textContent = unavailableLabel;
        }
        setQuantityEnabled(false);
        return;
      }

      if (variant.available) {
        addButton.removeAttribute('disabled');
        addButton.classList.remove('is-disabled');
        addButton.setAttribute('aria-disabled', 'false');
        addButton.textContent = defaultLabel;
        if (productStatus) {
          productStatus.textContent = '';
        }
        setQuantityEnabled(true);
      } else {
        addButton.setAttribute('disabled', 'disabled');
        addButton.classList.add('is-disabled');
        addButton.setAttribute('aria-disabled', 'true');
        addButton.textContent = soldOutLabel;
        if (productStatus) {
          productStatus.textContent = soldOutLabel;
        }
        setQuantityEnabled(false);
      }
    };

    const setPriceState = function (variant) {
      if (!currentPriceNode) return;
      if (!variant) return;

      currentPriceNode.textContent = formatVariantMoney(variant.price);

      if (priceVariantNode && variant.title && variant.title !== 'Default Title') {
        priceVariantNode.textContent = '/ ' + variant.title;
      }

      if (!priceNode) return;

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (!comparePriceNode) {
          comparePriceNode = document.createElement('span');
          comparePriceNode.className = 'ag-product__price-compare';
          comparePriceNode.setAttribute('data-product-price-compare', '');
          priceNode.insertBefore(comparePriceNode, currentPriceNode);
        }
        comparePriceNode.textContent = formatVariantMoney(variant.compare_at_price);
      } else if (comparePriceNode) {
        comparePriceNode.remove();
        comparePriceNode = null;
      }
    };

    const setImageState = function (variant) {
      if (!productImage || !variant) return;

      if (mediaThumbs.length) {
        return;
      }
    };

    const applyVariantState = function (variant) {
      if (variantInput) {
        variantInput.value = variant ? variant.id : '';
      }
      setButtonState(variant);
      setPriceState(variant);
      setStockState(variant);
      setSoldOutState(variant);
      setLowStockState(variant);
      setImageState(variant);
    };

    const pickVariant = function () {
      if (!optionSelects.length) {
        if (variantInput && variantInput.value) {
          const existingVariant = variants.find(function (variant) {
            return String(variant.id) === String(variantInput.value);
          });
          if (existingVariant) return existingVariant;
        }

        return variants[0] || null;
      }

      const values = [];
      optionSelects.forEach(function (select) {
        values.push(select.value);
      });

      return variants.find(function (variant) {
        return (
          variant.option1 === values[0] &&
          (values[1] ? variant.option2 === values[1] : true) &&
          (values[2] ? variant.option3 === values[2] : true)
        );
      });
    };

    const onOptionChange = function () {
      optionPills.forEach(function (pill) {
        const optionIndex = pill.getAttribute('data-option-index');
        const optionValue = pill.getAttribute('data-option-value');
        const select = optionSelects[Number(optionIndex)];
        const isActive = !!(select && select.value === optionValue);
        pill.classList.toggle('is-active', isActive);
        pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      applyVariantState(pickVariant());
    };
    optionSelects.forEach(function (select) {
      select.addEventListener('change', onOptionChange);
      cleanupListeners.push(function () {
        select.removeEventListener('change', onOptionChange);
      });
    });

    optionPills.forEach(function (pill) {
      const onPillClick = function () {
        const optionIndex = Number(pill.getAttribute('data-option-index'));
        const optionValue = pill.getAttribute('data-option-value');
        const select = optionSelects[optionIndex];
        if (!select || select.value === optionValue) return;
        select.value = optionValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      };
      pill.addEventListener('click', onPillClick);
      cleanupListeners.push(function () {
        pill.removeEventListener('click', onPillClick);
      });
    });

    if (qtyInput) {
      qtyInput.addEventListener('input', updateQuantityButtons);
      qtyInput.addEventListener('change', updateQuantityButtons);
      cleanupListeners.push(function () {
        qtyInput.removeEventListener('input', updateQuantityButtons);
        qtyInput.removeEventListener('change', updateQuantityButtons);
      });
    }
    const onQtyDecrease = function () {
      const current = sanitizeQuantity(qtyInput.value);
      qtyInput.value = String(Math.max(1, current - 1));
      updateQuantityButtons();
    };
    if (qtyDecreaseButton && qtyInput) {
      qtyDecreaseButton.addEventListener('click', onQtyDecrease);
      cleanupListeners.push(function () {
        qtyDecreaseButton.removeEventListener('click', onQtyDecrease);
      });
    }
    const onQtyIncrease = function () {
      const current = sanitizeQuantity(qtyInput.value);
      qtyInput.value = String(Math.min(99, current + 1));
      updateQuantityButtons();
    };
    if (qtyIncreaseButton && qtyInput) {
      qtyIncreaseButton.addEventListener('click', onQtyIncrease);
      cleanupListeners.push(function () {
        qtyIncreaseButton.removeEventListener('click', onQtyIncrease);
      });
    }

    mediaThumbs.forEach(function (thumb) {
      const onThumbClick = function () {
        activateMediaByThumb(thumb);
      };
      thumb.addEventListener('click', onThumbClick);
      cleanupListeners.push(function () {
        thumb.removeEventListener('click', onThumbClick);
      });
    });

    const onMediaPrev = function () {
      activateMediaByIndex(getActiveThumbIndex() - 1);
    };
    if (mediaPrevButton && mediaThumbs.length > 1) {
      mediaPrevButton.addEventListener('click', onMediaPrev);
      cleanupListeners.push(function () {
        mediaPrevButton.removeEventListener('click', onMediaPrev);
      });
    }
    const onMediaNext = function () {
      activateMediaByIndex(getActiveThumbIndex() + 1);
    };
    if (mediaNextButton && mediaThumbs.length > 1) {
      mediaNextButton.addEventListener('click', onMediaNext);
      cleanupListeners.push(function () {
        mediaNextButton.removeEventListener('click', onMediaNext);
      });
    }

    const initialVariant = pickVariant();
    applyVariantState(initialVariant);

    if (mediaThumbs.length) {
      activateMediaByThumb(mediaThumbs[0]);
    }
    updateQuantityButtons();
  };

  const initProductStickyBar = function () {
    const bar = document.querySelector('[data-product-sticky-bar]');
    const form = document.querySelector('.ag-product__form');
    const hero = document.querySelector('.ag-product-hero');
    if (!bar || !form || !hero) return;

    const qtyInput = form.querySelector('[data-qty-input]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const stickyQty = bar.querySelector('[data-sticky-qty]');
    const stickyDecrease = bar.querySelector('[data-sticky-qty-decrease]');
    const stickyIncrease = bar.querySelector('[data-sticky-qty-increase]');
    const stickyAdd = bar.querySelector('[data-sticky-add-to-cart]');

    const syncQty = function () {
      if (!qtyInput || !stickyQty) return;
      stickyQty.textContent = qtyInput.value || '1';
    };

    var scrollTimer = null;

    const setVisibility = function () {
      const heroRect = hero.getBoundingClientRect();
      const pastHero = heroRect.bottom < window.innerHeight * 0.4;

      if (!pastHero) {
        bar.classList.remove('is-visible', 'is-scrolling');
        clearTimeout(scrollTimer);
        return;
      }

      bar.classList.add('is-visible', 'is-scrolling');
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        bar.classList.remove('is-scrolling');
      }, 300);
    };

    if (qtyInput) {
      qtyInput.addEventListener('input', syncQty);
      qtyInput.addEventListener('change', syncQty);
      cleanupListeners.push(function () {
        qtyInput.removeEventListener('input', syncQty);
        qtyInput.removeEventListener('change', syncQty);
      });
    }

    if (stickyDecrease && qtyInput) {
      const onStickyDecrease = function () {
        qtyInput.value = String(Math.max(1, parseInt(qtyInput.value || '1', 10) - 1));
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      };
      stickyDecrease.addEventListener('click', onStickyDecrease);
      cleanupListeners.push(function () { stickyDecrease.removeEventListener('click', onStickyDecrease); });
    }

    if (stickyIncrease && qtyInput) {
      const onStickyIncrease = function () {
        qtyInput.value = String(Math.min(99, parseInt(qtyInput.value || '1', 10) + 1));
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      };
      stickyIncrease.addEventListener('click', onStickyIncrease);
      cleanupListeners.push(function () { stickyIncrease.removeEventListener('click', onStickyIncrease); });
    }

    if (stickyAdd && addButton) {
      const onStickyAdd = function () {
        addButton.click();
      };
      stickyAdd.addEventListener('click', onStickyAdd);
      cleanupListeners.push(function () { stickyAdd.removeEventListener('click', onStickyAdd); });
    }

    bar.removeAttribute('hidden');

    window.addEventListener('scroll', setVisibility, { passive: true });
    window.addEventListener('resize', setVisibility, { passive: true });
    cleanupListeners.push(function () {
      window.removeEventListener('scroll', setVisibility);
      window.removeEventListener('resize', setVisibility);
      clearTimeout(scrollTimer);
    });

    syncQty();
    setVisibility();
  };

  const initMobileMenu = function () {
    const header = document.querySelector('.ag-header');
    if (!header) return;
    const headerWrap = document.querySelector('.ag-header-wrap');
    const headerFrame = document.querySelector('.ag-site-frame__header');

    const toggle = header.querySelector('[data-menu-toggle]');
    if (!toggle) return;

    const controlledNavId = toggle.getAttribute('aria-controls');
    const nav = controlledNavId ? document.getElementById(controlledNavId) : null;
    if (!nav) return;
    const menuPanel = nav.querySelector('[data-menu-panel]');
    const overlay = nav.querySelector('[data-menu-overlay]');

    let isOpen = false;
    let lockedScrollY = 0;
    const syncMenuViewport = function () {
      if (!nav) return;
      if (window.innerWidth > 767) {
        nav.style.top = '';
        nav.style.height = '';
        nav.style.bottom = '';
        return;
      }
      const headerRect = header.getBoundingClientRect();
      const menuTop = Math.max(0, Math.round(headerRect.bottom));
      const menuHeight = Math.max(0, Math.round(window.innerHeight - menuTop));
      nav.style.setProperty('top', menuTop + 'px', 'important');
      nav.style.setProperty('bottom', '0px', 'important');
      nav.style.setProperty('height', menuHeight + 'px', 'important');
      nav.style.setProperty('max-height', menuHeight + 'px', 'important');
      nav.style.setProperty('animation', 'none', 'important');
      nav.style.setProperty('transform', 'none', 'important');
      nav.style.setProperty('opacity', '1', 'important');
    };

    const lockScroll = function () {
      lockedScrollY = window.scrollY || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + lockedScrollY + 'px';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    };

    const unlockScroll = function () {
      const top = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      if (top) {
        window.scrollTo(0, Math.abs(parseInt(top, 10) || 0));
      }
    };

    const focusableMenuSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const trapMenuFocus = function (event) {
      if (event.key !== 'Tab') return;
      const panelFocusables = Array.prototype.slice.call(
        menuPanel ? menuPanel.querySelectorAll(focusableMenuSelector) : []
      ).filter(function (el) { return el.offsetParent !== null; });
      const focusable = [toggle].concat(panelFocusables);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    const setMenuState = function (open) {
      isOpen = open;
      if (open) {
        document.dispatchEvent(new CustomEvent('agriko:close-cart-drawer'));
      }
      header.classList.toggle('is-menu-open', open);
      document.documentElement.classList.toggle('ag-menu-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      nav.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) {
        nav.hidden = false;
        // Safety: ensure the menu is above hero/media layers even if CDN-cached CSS is stale.
        nav.style.setProperty('z-index', 'var(--ag-z-modal)', 'important');
        // If the header wrapper is transformed (auto-hide), fixed children can end up behind page content.
        if (headerWrap) {
          headerWrap.style.setProperty('transform', 'none', 'important');
          headerWrap.style.setProperty('z-index', 'var(--ag-z-modal)', 'important');
        }
        if (headerFrame) headerFrame.style.setProperty('z-index', 'var(--ag-z-modal)', 'important');
        nav.setAttribute('aria-modal', 'true');
        nav.removeAttribute('inert');
        syncMenuViewport();
        lockScroll();
        document.addEventListener('keydown', trapMenuFocus);
        setTimeout(function () { toggle.focus(); }, 50);
      } else {
        nav.removeAttribute('aria-modal');
        nav.setAttribute('inert', '');
        nav.hidden = true;
        unlockScroll();
        nav.style.removeProperty('z-index');
        if (headerWrap) {
          headerWrap.style.removeProperty('transform');
          headerWrap.style.removeProperty('z-index');
        }
        if (headerFrame) headerFrame.style.removeProperty('z-index');
        nav.style.removeProperty('top');
        nav.style.removeProperty('height');
        nav.style.removeProperty('max-height');
        nav.style.removeProperty('bottom');
        nav.style.removeProperty('animation');
        nav.style.removeProperty('transform');
        nav.style.removeProperty('opacity');
        document.removeEventListener('keydown', trapMenuFocus);
      }
    };

    // Clean up any residual scroll lock styles from page cache/back navigation
    const cleanupScrollLock = function () {
      if (document.body.style.position === 'fixed' && document.body.style.top) {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        window.scrollTo(0, 0);
      }
    };

    cleanupScrollLock();
    setMenuState(false);

    document.addEventListener('agriko:close-mobile-menu', function () {
      if (!isOpen) return;
      setMenuState(false);
    });

    toggle.addEventListener('click', function () {
      setMenuState(!isOpen);
    });

    toggle.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!isOpen) return;
      setMenuState(false);
    });

    nav.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!isOpen) return;
      setMenuState(false);
      toggle.focus();
    });

    nav.addEventListener('click', function (event) {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (!target.closest('a')) return;
      if (!isOpen) return;
      setMenuState(false);
    });

    if (overlay) {
      overlay.addEventListener('click', function () {
        if (!isOpen) return;
        setMenuState(false);
      });
    }

    const mousedownHandler = function (event) {
      if (!isOpen) return;
      const target = event.target;
      if (!(target instanceof Node)) return;
      if (toggle.contains(target)) return;
      if (menuPanel && menuPanel.contains(target)) return;
      setMenuState(false);
    };
    document.addEventListener('mousedown', mousedownHandler);
    cleanupListeners.push(function () {
      document.removeEventListener('mousedown', mousedownHandler);
    });

    window.addEventListener('pagehide', function () {
      unlockScroll();
    });

    let resizeRafId;
    window.addEventListener('resize', function () {
      if (!isOpen) return;
      if (resizeRafId) return;
      resizeRafId = requestAnimationFrame(function () {
        syncMenuViewport();
        resizeRafId = null;
      });
    });
  };

  const initHeaderAutoHide = function () {
    const headerWrap = document.querySelector('.ag-header-wrap');
    const headerFrame = document.querySelector('.ag-site-frame__header');
    const header = document.querySelector('.ag-header');
    if (!headerWrap || !header) return;

    let lastY = window.scrollY || 0;
    let ticking = false;
    let downAccum = 0;          /* cumulative downward px since last upward movement */

    const TOP_THRESHOLD    = 80;  /* px — always visible above this */
    const SHADOW_THRESHOLD = 10;  /* px — shadow appears above this */
    const DOWN_TO_HIDE     = 300;  /* px of continuous downward scroll to trigger hide */

    const setHidden = function (hidden) {
      headerWrap.classList.toggle('is-hidden', hidden);
      if (headerFrame) headerFrame.classList.toggle('is-hidden', hidden);
    };

    const updateHeaderState = function () {
      const currentY = window.scrollY || 0;
      const delta = currentY - lastY;

      headerWrap.classList.toggle('header--scrolled', currentY > SHADOW_THRESHOLD);
      headerWrap.classList.toggle('is-scrolled', currentY > 20);

      if (header.classList.contains('is-menu-open')) {
        downAccum = 0;
        setHidden(false);
        lastY = currentY;
        ticking = false;
        return;
      }

      if (currentY <= TOP_THRESHOLD) {
        downAccum = 0;
        setHidden(false);
        lastY = currentY;
        ticking = false;
        return;
      }

      if (delta > 0) {
        /* scrolling down — accumulate */
        downAccum += delta;
        if (downAccum >= DOWN_TO_HIDE) {
          setHidden(true);
        }
      } else if (delta < 0) {
        /* any upward scroll — show immediately, reset accumulator */
        downAccum = 0;
        setHidden(false);
      }

      lastY = currentY;
      ticking = false;
    };

    const scrollListener = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateHeaderState);
    };

    const pageshowListener = function () {
      setHidden(false);
      downAccum = 0;
      lastY = window.scrollY || 0;
    };

    window.addEventListener('scroll', scrollListener, { passive: true });
    window.addEventListener('pageshow', pageshowListener);

    cleanupListeners.push(function () {
      window.removeEventListener('scroll', scrollListener);
      window.removeEventListener('pageshow', pageshowListener);
    });
  };

  const initCartDrawer = function () {
    // Guard: don't initialize cart drawer on article pages (prevents auto-open overlay)
    if (typeof Shopify !== 'undefined' && Shopify.page && Shopify.page.type === 'article') {
      return;
    }

    const shell = document.querySelector('.ag-shell');
    if (!shell) return;

    const toggle = document.querySelector('[data-cart-toggle]');
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    const panel = drawer.querySelector('[data-cart-panel]') || drawer.querySelector('.ag-cart-drawer__panel');
    const overlay = drawer.querySelector('[data-cart-overlay]');
    const closeBtn = drawer.querySelector('[data-cart-close]');
    const itemsNode = drawer.querySelector('[data-cart-items]');
    const subtotalNode = drawer.querySelector('[data-cart-subtotal]');
    const countNode = drawer.querySelector('[data-cart-count]');
    const shippingProgress = drawer.querySelector('[data-shipping-progress]');
    const currencyCode = drawer.getAttribute('data-currency') || 'USD';
    let isOpen = false;
    let isUpdating = false;

    const formatDrawerMoney = function (cents) {
      return formatMoney(cents, currencyCode);
    };

    const getBadge = function () {
      return document.querySelector('.ag-header__badge');
    };

    const updateBadge = function (count) {
      let badgeNode = getBadge();
      if (count > 0) {
        if (!badgeNode) {
          const cartIcon = document.querySelector('.ag-header__icon-link--cart');
          if (cartIcon) {
            badgeNode = document.createElement('span');
            badgeNode.className = 'ag-header__badge';
            cartIcon.appendChild(badgeNode);
          }
        }
        if (badgeNode) {
          badgeNode.textContent = String(count);
        }
      } else if (badgeNode) {
        badgeNode.remove();
      }
    };

    const updateCount = function (count) {
      if (countNode) {
        countNode.textContent = '(' + count + ')';
      }
      updateBadge(count);
    };

    const updateSubtotal = function (total) {
      if (subtotalNode) {
        subtotalNode.textContent = formatDrawerMoney(total);
      }
    };

    const updateShippingProgress = function (totalPrice) {
      if (!shippingProgress) return;
      const thresholdAttr = shippingProgress.getAttribute('data-threshold');
      if (!thresholdAttr) return;

      const threshold = parseInt(thresholdAttr, 10) * 100;
      const remaining = threshold - totalPrice;
      const fillBar = shippingProgress.querySelector('.ag-cart-drawer__shipping-fill');
      const textEl = shippingProgress.querySelector('.ag-cart-drawer__shipping-text');

      if (remaining > 0) {
        const percentage = Math.min(100, (totalPrice / threshold) * 100);
        if (fillBar) fillBar.style.width = percentage + '%';
        if (textEl) {
          // Safe: formatDrawerMoney returns sanitized text, user input is currency value only
          textEl.textContent = '';
          // Bold wrapper for styling - safe as content is already sanitized
          const boldSpan = document.createElement('span');
          boldSpan.style.fontWeight = 'bold';
          boldSpan.textContent = formatDrawerMoney(remaining);
          textEl.innerHTML = '';
          textEl.appendChild(document.createTextNode('Add '));
          textEl.appendChild(boldSpan);
          textEl.appendChild(document.createTextNode(''));
          textEl.classList.remove('ag-cart-drawer__shipping-text--success');
        }
      } else {
        if (fillBar) fillBar.style.width = '100%';
        if (textEl) {
          textEl.textContent = '';
          const svgNS = 'http://www.w3.org/2000/svg';
          const svg = document.createElementNS(svgNS, 'svg');
          svg.setAttribute('width', '16');
          svg.setAttribute('height', '16');
          svg.setAttribute('viewBox', '0 0 24 24');
          svg.setAttribute('fill', 'none');
          svg.setAttribute('stroke', 'currentColor');
          svg.setAttribute('stroke-width', '2');
          const polyline = document.createElementNS(svgNS, 'polyline');
          polyline.setAttribute('points', '20 6 9 17 4 12');
          svg.appendChild(polyline);
          textEl.appendChild(svg);
          textEl.appendChild(document.createTextNode(''));
          textEl.classList.add('ag-cart-drawer__shipping-text--success');
        }
      }
    };

    const escapeHtml = function (str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    };

    const renderItem = function (item) {
      const imageUrl = item.image || '';
      const variantText = item.variant_title && item.variant_title !== 'Default Title' ? escapeHtml(item.variant_title) : '';
      const productTitleEscaped = escapeHtml(item.product_title);
      const itemKeyEscaped = escapeHtml(String(item.key));
      const variantIdEscaped = escapeHtml(String(item.variant_id));
      const quantityEscaped = escapeHtml(String(item.quantity));
      const linePriceEscaped = escapeHtml(formatDrawerMoney(item.final_line_price));

      let propertiesHtml = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (key) {
          const value = item.properties[key];
          if (value) {
            propertiesHtml += '<p class="ag-cart-drawer__item-meta">' + escapeHtml(String(key)) + ': ' + escapeHtml(String(value)) + '</p>';
          }
        });
      }

      // Validate and sanitize URL to prevent XSS
      let safeUrl = '';
      if (item.url) {
        try {
          const urlObj = new URL(item.url, window.location.origin);
          // Only allow relative URLs or same-origin URLs
          if (urlObj.origin === window.location.origin || urlObj.protocol === 'http:' || urlObj.protocol === 'https:') {
            // For same-origin or absolute URLs, use pathname to ensure it's a relative path
            safeUrl = urlObj.pathname;
          }
        } catch (e) {
          // If URL parsing fails, use empty string
          console.warn('Invalid product URL:', item.url);
        }
      }

      // Sanitize image URL
      let safeImageUrl = '';
      if (imageUrl) {
        try {
          const imgUrlObj = new URL(imageUrl, window.location.origin);
          if (imgUrlObj.origin === window.location.origin || imgUrlObj.protocol === 'http:' || imgUrlObj.protocol === 'https:') {
            safeImageUrl = escapeHtml(imageUrl);
          }
        } catch (e) {
          console.warn('Invalid image URL:', imageUrl);
        }
      }

      return '<li class="ag-cart-drawer__item" data-cart-item data-key="' + itemKeyEscaped + '" data-variant-id="' + variantIdEscaped + '">' +
        (safeImageUrl ? '<a href="' + escapeHtml(safeUrl) + '" class="ag-cart-drawer__item-image-link"><img src="' + safeImageUrl + '" alt="' + productTitleEscaped + '" class="ag-cart-drawer__item-img" width="80" height="80" loading="lazy"></a>' : '<div class="ag-cart-drawer__item-image-placeholder"></div>') +
        '<div class="ag-cart-drawer__item-details">' +
        '<a href="' + escapeHtml(safeUrl) + '" class="ag-cart-drawer__item-title">' + productTitleEscaped + '</a>' +
        (variantText ? '<p class="ag-cart-drawer__item-meta">' + variantText + '</p>' : '') +
        propertiesHtml +
        '<div class="ag-cart-drawer__item-controls">' +
        '<div class="ag-cart-drawer__quantity">' +
        '<button type="button" class="ag-cart-drawer__qty-btn" data-qty-decrease aria-label="Decrease quantity"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"></line></svg></button>' +
        '<input type="number" class="ag-cart-drawer__qty-input" data-qty-input value="' + quantityEscaped + '" min="0" max="99" aria-label="Quantity">' +
        '<button type="button" class="ag-cart-drawer__qty-btn" data-qty-increase aria-label="Increase quantity"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg></button>' +
        '</div>' +
        '<p class="ag-cart-drawer__item-line" data-line-price>' + linePriceEscaped + '</p>' +
        '</div>' +
        '<button type="button" class="ag-cart-drawer__item-remove" data-cart-remove aria-label="Remove ' + productTitleEscaped + ' from cart">Remove</button>' +
        '</div>' +
        '</li>';
    };

    const renderEmptyCart = function () {
      const emptyTitle = 'Your cart is empty';
      const emptyText = 'Start shopping to fill your cart with great products.';

      return '<div class="ag-cart-drawer__empty" data-cart-empty aria-label="' + emptyTitle + '. ' + emptyText + '">' +
        '<svg class="ag-cart-drawer__empty-icon" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>' +
        '<h3 class="ag-cart-drawer__empty-title">' + emptyTitle + '</h3>' +
        '<p class="ag-cart-drawer__empty-text">' + emptyText + '</p>' +
        '<a href="/collections/shop-all" class="ag-button ag-button--primary ag-cart-drawer__empty-cta">Continue Shopping</a>' +
        '</div>';
    };

    const renderItems = function (cart) {
      // Always update count, subtotal, and shipping (even if drawer not yet opened)
      updateSubtotal(cart.total_price);
      updateCount(cart.item_count);
      updateShippingProgress(cart.total_price);

      // Announce cart change to screen readers (A11Y-008)
      const statusEl = drawer.querySelector('[data-cart-status]');
      if (statusEl) {
        statusEl.textContent = cart.items && cart.items.length
          ? 'Cart updated. ' + cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '') + ' in cart.'
          : 'Cart is now empty.';
      }

      if (!itemsNode) return;

      if (!cart.items || !cart.items.length) {
        itemsNode.innerHTML = renderEmptyCart();
        hideFooter();
        return;
      }

      showFooter();
      let html = '<ul class="ag-cart-drawer__list" role="list">';
      cart.items.forEach(function (item) {
        html += renderItem(item);
      });
      html += '</ul>';
      itemsNode.innerHTML = html;
      bindItemEvents();
    };

    // Cache footer element to avoid repeated DOM queries
    let footerElement = null;

    const showFooter = function () {
      if (!footerElement) {
        footerElement = drawer.querySelector('.ag-cart-drawer__footer');
      }
      if (footerElement) footerElement.style.display = '';
    };

    const hideFooter = function () {
      if (!footerElement) {
        footerElement = drawer.querySelector('.ag-cart-drawer__footer');
      }
      if (footerElement) footerElement.style.display = 'none';
    };

    const loadCart = function () {
      if (!itemsNode) return;
      itemsNode.innerHTML = '<p class="ag-cart-drawer__loading">Loading cart...</p>';
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (cart) { renderItems(cart); })
        .catch(function () {
          itemsNode.innerHTML = '<p class="ag-cart-drawer__empty">Unable to load cart right now.</p>';
        });
    };

    const fetchCart = function () {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); });
    };

    const updateCartItem = function (key, quantity) {
      isUpdating = true;
      drawer.classList.add('is-updating');

      const itemEl = drawer.querySelector('[data-key="' + key + '"]');
      if (itemEl) itemEl.classList.add('is-loading');

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart update failed: ' + res.status);
          return res.json();
        })
        .then(function (cart) {
          renderItems(cart);
          return cart;
        })
        .catch(function (err) {
          console.error('Cart update failed:', err);
          // Show user-facing error message
          let errorDiv = drawer.querySelector('.ag-cart-drawer__error');
          if (!errorDiv) {
            errorDiv = document.createElement('div');
            errorDiv.className = 'ag-cart-drawer__error';
            drawer.insertBefore(errorDiv, itemsNode);
          }
          errorDiv.setAttribute('role', 'alert');
          errorDiv.textContent = 'Unable to update cart. Please try again.';
          errorDiv.hidden = false;
          setTimeout(function () {
            errorDiv.hidden = true;
          }, 5000);
        })
        .finally(function () {
          isUpdating = false;
          drawer.classList.remove('is-updating');
          if (itemEl) itemEl.classList.remove('is-loading');
        });
    };

    const removeCartItem = function (key) {
      return updateCartItem(key, 0);
    };

    const bindItemEvents = function () {
      const items = drawer.querySelectorAll('[data-cart-item]');
      items.forEach(function (item) {
        const key = item.getAttribute('data-key');
        const qtyInput = item.querySelector('[data-qty-input]');
        const decreaseBtn = item.querySelector('[data-qty-decrease]');
        const increaseBtn = item.querySelector('[data-qty-increase]');
        const removeBtn = item.querySelector('[data-cart-remove]');

        if (decreaseBtn) {
          decreaseBtn.addEventListener('click', function () {
            if (isUpdating) return;
            const currentQty = parseInt(qtyInput.value, 10) || 1;
            if (currentQty > 1) {
              updateCartItem(key, currentQty - 1);
            } else {
              removeCartItem(key);
            }
          });
        }

        if (increaseBtn) {
          increaseBtn.addEventListener('click', function () {
            if (isUpdating) return;
            const currentQty = parseInt(qtyInput.value, 10) || 1;
            updateCartItem(key, Math.min(99, currentQty + 1));
          });
        }

        if (qtyInput) {
          qtyInput.addEventListener('change', function () {
            if (isUpdating) return;
            const newQty = parseInt(qtyInput.value, 10);
            if (isNaN(newQty) || newQty < 1) {
              removeCartItem(key);
            } else {
              updateCartItem(key, Math.min(99, newQty));
            }
          });
        }

        if (removeBtn) {
          removeBtn.addEventListener('click', function () {
            if (isUpdating) return;
            removeCartItem(key);
          });
        }
      });
    };

    let previousFocus = null;

    const focusableDrawerSelector = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const trapDrawerFocus = function (event) {
      if (event.key !== 'Tab') return;
      const focusable = Array.prototype.slice.call(
        panel ? panel.querySelectorAll(focusableDrawerSelector) : []
      ).filter(function (el) { return el.offsetParent !== null; });
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    const setState = function (open) {
      isOpen = open;
      if (open) {
        document.dispatchEvent(new CustomEvent('agriko:close-mobile-menu'));
      }
      shell.classList.toggle('is-cart-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) {
        drawer.hidden = false;
        drawer.removeAttribute('inert');
      } else {
        drawer.setAttribute('inert', '');
        drawer.hidden = true;
      }
      if (toggle) {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      if (overlay) {
        overlay.disabled = !open;
        overlay.tabIndex = open ? 0 : -1;
        overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
      }
      if (panel) {
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (open) {
          panel.setAttribute('role', 'dialog');
          panel.setAttribute('aria-modal', 'true');
          panel.removeAttribute('inert');
        } else {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-modal');
          panel.setAttribute('inert', '');
        }
      }
      if (open) {
        // Store current focus element before opening
        previousFocus = document.activeElement;
        loadCart();
        // Move focus to close button and activate focus trap
        setTimeout(function () {
          if (closeBtn) closeBtn.focus();
        }, 100);
        if (panel) panel.addEventListener('keydown', trapDrawerFocus);
      } else {
        // Deactivate trap and return focus to trigger element
        if (panel) panel.removeEventListener('keydown', trapDrawerFocus);
        if (previousFocus && previousFocus.focus) {
          setTimeout(function () {
            previousFocus.focus();
          }, 100);
        }
      }
    };

    const openDrawer = function () {
      if (!isOpen) setState(true);
    };

    const closeDrawer = function () {
      if (isOpen) setState(false);
    };

    setState(false);

    document.addEventListener('agriko:close-cart-drawer', function () {
      closeDrawer();
    });

    if (toggle) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        setState(!isOpen);
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function () {
        setState(false);
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        setState(false);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!isOpen) return;
      setState(false);
    });

    document.addEventListener('ag:cart:open', openDrawer);
    document.addEventListener('ag:cart:close', closeDrawer);
    document.addEventListener('ag:cart:refresh', function () {
      if (isOpen) loadCart();
    });

    document.addEventListener('ag:cart:updated', function (event) {
      if (event && event.detail) {
        const cart = event.detail;
        renderItems(cart);
        // Don't auto-open cart drawer on add to cart
        // User can click cart icon to view cart
      } else {
        fetchCart().then(function (cart) {
          renderItems(cart);
          // Don't auto-open cart drawer
        }).catch(function () {
          // Silently handle network errors — cart shows stale data
        });
      }
    });

    setState(false);
  };

  const initCookieBanner = function () {
    const banner = document.querySelector('[data-ag-cookie-banner]');
    if (!banner) return;

    const rejectBtn = banner.querySelector('[data-cookie-reject]');
    const acceptBtn = banner.querySelector('[data-cookie-accept]');
    const closeBtn = banner.querySelector('[data-cookie-close]');
    const focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const CONSENT_EXPIRY_DAYS = 365;
    const SAFETY_BUFFER_MS = 5 * 60 * 1000;

    const storageKey = banner.getAttribute('data-consent-key') || 'agriko_cookie_consent';

    const getStoredConsent = function () {
      try {
        if (!window.localStorage) return null;
        const stored = localStorage.getItem(storageKey);
        if (!stored) return null;
        const parsed = JSON.parse(stored);
        const expiryTime = new Date(parsed.timestamp).getTime() + (CONSENT_EXPIRY_DAYS * 24 * 60 * 60 * 1000);
        if (Date.now() < expiryTime - SAFETY_BUFFER_MS) {
          return parsed;
        }
        localStorage.removeItem(storageKey);
        return null;
      } catch (err) {
        return null;
      }
    };

    const saveConsent = function (choice) {
      try {
        if (!window.localStorage) return;
        const data = {
          choice: choice,
          timestamp: new Date().toISOString()
        };
        localStorage.setItem(storageKey, JSON.stringify(data));
        window.dispatchEvent(new StorageEvent('storage', {
          key: storageKey,
          newValue: JSON.stringify(data),
          oldValue: null,
          storageArea: localStorage
        }));
      } catch (err) {
        console.warn('Failed to save consent to localStorage:', err);
      }
    };

    const updateFacebookConsent = function (granted) {
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('consent', granted ? 'grant' : 'revoke');
      }
    };

    const hideBanner = function () {
      banner.classList.remove('is-visible');
      setTimeout(function () {
        banner.hidden = true;
      }, 300);
    };

    const showBanner = function () {
      banner.hidden = false;
      requestAnimationFrame(function () {
        banner.classList.add('is-visible');
      });
      if (acceptBtn) acceptBtn.focus();
    };

    const handleAccept = function () {
      saveConsent('accept');
      updateFacebookConsent(true);
      hideBanner();
    };

    const handleReject = function () {
      saveConsent('reject');
      updateFacebookConsent(false);
      hideBanner();
    };

    const handleClose = function () {
      saveConsent('dismissed');
      hideBanner();
    };

    const trapFocus = function (event) {
      if (event.key !== 'Tab') return;
      const focusableEls = banner.querySelectorAll(focusableSelector);
      const focusable = Array.prototype.slice.call(focusableEls).filter(function (el) {
        return !el.disabled && el.offsetParent !== null;
      });
      if (!focusable.length) return;
      const firstEl = focusable[0];
      const lastEl = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === firstEl) {
        event.preventDefault();
        lastEl.focus();
      } else if (!event.shiftKey && document.activeElement === lastEl) {
        event.preventDefault();
        firstEl.focus();
      }
    };

    const handleKeydown = function (event) {
      if (event.key === 'Escape') {
        handleClose();
      }
      trapFocus(event);
    };

    const storedConsent = getStoredConsent();
    if (storedConsent) {
      if (storedConsent.choice === 'accept') {
        updateFacebookConsent(true);
      } else if (storedConsent.choice === 'reject') {
        updateFacebookConsent(false);
      }
      banner.remove();
      return;
    }

    if (rejectBtn) {
      rejectBtn.addEventListener('click', handleReject);
    }

    if (acceptBtn) {
      acceptBtn.addEventListener('click', handleAccept);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', handleClose);
    }

    banner.addEventListener('keydown', handleKeydown);

    window.addEventListener('storage', function (event) {
      if (event.key !== storageKey) return;
      if (event.newValue) {
        try {
          const data = JSON.parse(event.newValue);
          if (data.choice === 'accept' || data.choice === 'reject' || data.choice === 'dismissed') {
            hideBanner();
          }
        } catch (err) {
          console.warn('Failed to parse consent data:', err);
        }
      }
    });

    showBanner();
  };

  const initRevealOnScroll = function () {
    if (typeof IntersectionObserver === 'undefined') return;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-reveal', 'active');
          entry.target.classList.add('is-revealed'); // Support backward compatibility
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    // Support both data-reveal and .reveal-on-scroll class
    const reveals = document.querySelectorAll('[data-reveal], .reveal-on-scroll');
    reveals.forEach(function (el) {
      observer.observe(el);
    });

    // Register cleanup for observer
    cleanupListeners.push(function () {
      observer.disconnect();
    });
  };

  const hardenHomepageMedia = function () {
    if (!document.body || !document.body.classList.contains('template-index')) return;
    const imageUrl = function (img) {
      if (!img) return '';
      return img.currentSrc || img.getAttribute('src') || '';
    };

    const hero = document.querySelector('.ag-home-hero, .ag-home-hero-DEPRECATED');
    const heroImg = hero ? hero.querySelector('.ag-home-hero__image, img') : null;
    const heroUrl = imageUrl(heroImg);
    if (hero && heroUrl) {
      hero.style.backgroundImage = `linear-gradient(rgba(7, 12, 9, 0.46), rgba(7, 12, 9, 0.58)), url("${heroUrl}")`;
      hero.style.backgroundPosition = 'center center';
      hero.style.backgroundSize = 'cover';
      hero.style.backgroundRepeat = 'no-repeat';
    }


  };

  const initFaqAccordion = function () {
    const sections = Array.prototype.slice.call(document.querySelectorAll('[data-faq-section]')).filter(function (section) {
      return !section.classList.contains('ag-home-faq');
    });
    if (!sections.length) return;

    sections.forEach(function (section) {
      const items = section.querySelectorAll('[data-faq-item]');
      const closeOthers = section.getAttribute('data-close-others') === 'true';

      items.forEach(function (item) {
        const trigger = item.querySelector('[data-faq-trigger]');
        const panel = item.querySelector('[data-faq-panel]');

        if (!trigger || !panel) return;

        const toggleItem = function (open) {
          const isOpen = open;
          item.classList.toggle('is-open', isOpen);
          trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        };

        trigger.addEventListener('click', function () {
          const currentlyOpen = item.classList.contains('is-open');

          if (closeOthers && !currentlyOpen) {
            items.forEach(function (otherItem) {
              if (otherItem !== item) {
                otherItem.classList.remove('is-open');
                const otherTrigger = otherItem.querySelector('[data-faq-trigger]');
                if (otherTrigger) {
                  otherTrigger.setAttribute('aria-expanded', 'false');
                }
              }
            });
          }

          toggleItem(!currentlyOpen);
        });

        trigger.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            trigger.click();
          }
        });
      });

      const handleAccordionKeyboard = function (event) {
        const focused = document.activeElement;
        if (!focused || !focused.hasAttribute('data-faq-trigger')) return;

        const triggers = Array.prototype.slice.call(section.querySelectorAll('[data-faq-trigger]'));
        const currentIndex = triggers.indexOf(focused);
        if (currentIndex === -1) return;

        let nextTrigger = null;

        if (event.key === 'ArrowDown' || (event.key === 'ArrowRight' && !event.metaKey)) {
          event.preventDefault();
          nextTrigger = triggers[(currentIndex + 1) % triggers.length];
        } else if (event.key === 'ArrowUp' || (event.key === 'ArrowLeft' && !event.metaKey)) {
          event.preventDefault();
          nextTrigger = triggers[(currentIndex - 1 + triggers.length) % triggers.length];
        } else if (event.key === 'Home') {
          event.preventDefault();
          nextTrigger = triggers[0];
        } else if (event.key === 'End') {
          event.preventDefault();
          nextTrigger = triggers[triggers.length - 1];
        }

        if (nextTrigger) {
          nextTrigger.focus();
        }
      };

      section.addEventListener('keydown', handleAccordionKeyboard);
    });
  };

  // Contact page FAQ - native details/summary enhancement
  const initContactPageFaq = function () {
    const faqSection = document.querySelector('.ag-contact__faq-section');
    if (!faqSection) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const faqItems = faqSection.querySelectorAll('.ag-contact__faq-item details');

    if (!faqItems.length) return;

    faqItems.forEach(function (item) {
      const summary = item.querySelector('summary');

      if (!summary) return;

      // Single open at a time behavior
      summary.addEventListener('click', function (e) {
        if (!item.open && !prefersReducedMotion) {
          faqItems.forEach(function (otherItem) {
            if (otherItem !== item && otherItem.open) {
              otherItem.removeAttribute('open');
            }
          });
        }
      });

      // Keyboard support
      summary.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          summary.click();
        }
      });
    });
  };

  // Fix weight badges display - convert "100 kg" to "100g", "1000 kg" to "1 kg"
  const fixWeightBadges = function () {
    const weightBadges = document.querySelectorAll('[data-card-badge-weight]');
    weightBadges.forEach(function (badge) {
      const text = badge.textContent.trim();
      // Match patterns like "100 kg", "120 kg", "450 kg", "500 kg", "1000 kg", "250 kg"
      const match = text.match(/^(\d+)\s*kg$/i);
      if (match) {
        const value = parseInt(match[1], 10);
        if (value >= 1000) {
          const kg = value / 1000;
          badge.textContent = (Number.isInteger(kg) ? kg : kg.toFixed(1)) + ' kg';
        } else {
          badge.textContent = value + 'g';
        }
      }
    });
  };

  const initCollectionCardVariants = function () {
    const cards = document.querySelectorAll('[data-card-product]');
    if (!cards.length) return;

    const formatCardMoney = function (cents, cardCurrency) {
      return formatMoney(cents, cardCurrency || 'PHP', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    };

    cards.forEach(function (card) {
      const variantsNode = card.querySelector('[data-card-variants]');
      const pillsContainer = card.querySelector('[data-card-variant-pills]');
      const selectEl = card.querySelector('[data-card-variant-select]');
      const variantInput = card.querySelector('[data-variant-id]');
      const addButton = card.querySelector('[data-add-to-cart]');
      const priceBlock = card.querySelector('.ag-card__price-block');
      const priceNode = card.querySelector('[data-card-price]');
      let compareNode = card.querySelector('[data-card-price-compare]');
      const weightNode = card.querySelector('[data-card-badge-weight]');
      const weightLabelNode = card.querySelector('[data-card-weight-label]');

      if (!variantsNode || (!pillsContainer && !selectEl) || !variantInput) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsNode.textContent || '[]');
      } catch (err) {
        variants = [];
      }
      if (!variants.length) return;

      const currencyCode = card.getAttribute('data-card-currency') || 'PHP';
      const defaultLabel = addButton ? (addButton.getAttribute('data-default-label') || 'Add') : 'Add';
      const soldOutLabel = addButton ? (addButton.getAttribute('data-sold-out-label') || 'Sold Out') : 'Sold Out';

      const findVariant = function (variantId) {
        return variants.find(function (variant) {
          return String(variant.id) === String(variantId);
        }) || null;
      };

      const formatWeight = function (weight, unit) {
        const value = Number(weight || 0);
        if (!(value > 0)) return 'Organic';

        // Shopify stores weight in grams by default
        // Check if weight is in grams (< 1000g = less than 1kg)
        if (value < 1000) {
          return String(value) + 'g';
        }

        // For weights >= 1000g (1kg), show in kg format
        const kgValue = value / 1000;
        const normalized = Number.isInteger(kgValue) ? String(kgValue) : String(kgValue).replace(/\.0+$/, '');
        return normalized + ' kg';
      };

      const applyVariantState = function (variant) {
        if (!variant) return;

        variantInput.value = variant.id;

        if (priceNode) {
          priceNode.textContent = formatCardMoney(variant.price, currencyCode);
        }

        if (compareNode) {
          if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
            compareNode.hidden = false;
            compareNode.textContent = formatCardMoney(variant.compare_at_price, currencyCode);
          } else {
            compareNode.hidden = true;
          }
        } else if (priceBlock && priceNode && variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
          compareNode = document.createElement('span');
          compareNode.className = 'ag-card__price-compare';
          compareNode.setAttribute('data-card-price-compare', '');
          compareNode.textContent = formatCardMoney(variant.compare_at_price, currencyCode);
          priceBlock.insertBefore(compareNode, priceNode);
        }

        if (addButton) {
          addButton.disabled = !variant.available;
          const textNode = addButton.querySelector('span');
          if (textNode) {
            textNode.textContent = variant.available ? defaultLabel : soldOutLabel;
          } else {
            addButton.textContent = variant.available ? defaultLabel : soldOutLabel;
          }
          const titleLink = card.querySelector('.ag-fc-card__title-link');
          if (titleLink) {
            const variantLabel = variant.title || '';
            const priceText = priceNode ? priceNode.textContent : '';
            const stateText = variant.available ? 'Add to Cart' : 'Sold Out';
            addButton.setAttribute('aria-label',
              titleLink.textContent.trim() + ' — ' + variantLabel + ' ' + priceText + ' — ' + stateText
            );
          }
        }

        if (weightNode) {
          weightNode.textContent = formatWeight(variant.weight, variant.weight_unit);
        }

        if (weightLabelNode) {
          weightLabelNode.textContent = variant.title && variant.title !== 'Default Title' ? variant.title : '';
        }

        // Update pill active states (legacy pills support)
        if (pillsContainer) {
          pillsContainer.querySelectorAll('[data-card-variant-pill]').forEach(function (pill) {
            const isActive = String(pill.getAttribute('data-card-variant-pill')) === String(variant.id);
            pill.classList.toggle('ag-variant-pill--active', isActive);
            pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        }

        // Update select value
        if (selectEl) {
          selectEl.value = String(variant.id);
        }
      };

      if (pillsContainer) {
        pillsContainer.addEventListener('click', function (e) {
          const pill = e.target.closest('[data-card-variant-pill]');
          if (!pill || pill.getAttribute('aria-disabled') === 'true') return;
          applyVariantState(findVariant(pill.getAttribute('data-card-variant-pill')));
          fixWeightBadges();
        });
      }

      if (selectEl) {
        selectEl.addEventListener('change', function () {
          applyVariantState(findVariant(selectEl.value));
          fixWeightBadges();
        });
      }

      applyVariantState(findVariant(selectEl ? selectEl.value : null) || variants[0]);
    });
  };

  const initAddToCart = function () {
    const forms = document.querySelectorAll('form[action="/cart/add"]');
    if (!forms.length) return;

    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        const submitBtn = form.querySelector('[data-add-to-cart]');
        let originalText = '';
        let loadingText = 'Adding...';

        if (submitBtn) {
          originalText = submitBtn.textContent;
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
          const loadingLabel = submitBtn.getAttribute('data-loading-label');
          if (loadingLabel) loadingText = loadingLabel;
          submitBtn.textContent = loadingText;
        }

        const formData = new FormData(form);
        const data = {
          id: formData.get('id'),
          quantity: parseInt(formData.get('quantity'), 10) || 1
        };

        const properties = {};
        formData.forEach(function (value, key) {
          if (key.indexOf('properties[') === 0) {
            const propName = key.replace('properties[', '').replace(']', '');
            if (value) properties[propName] = value;
          }
        });
        if (Object.keys(properties).length > 0) {
          data.properties = properties;
        }

        var hadError = false;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(data)
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Failed to add item');
            return res.json();
          })
          .then(function (item) {
            document.dispatchEvent(new CustomEvent('ag:cart:added', { detail: { title: item.title } }));
            return fetch('/cart.js', { credentials: 'same-origin' });
          })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('ag:cart:updated', { detail: cart }));
          })
          .catch(function (err) {
            hadError = true;
            console.error('Add to cart error:', err);
            if (submitBtn) {
              submitBtn.textContent = 'Error';
              setTimeout(function () {
                submitBtn.textContent = originalText;
                submitBtn.disabled = false;
              }, 2000);
            }
          })
          .finally(function () {
            if (submitBtn) {
              submitBtn.removeAttribute('aria-busy');
              if (!hadError) {
                submitBtn.disabled = false;
                submitBtn.textContent = originalText;
              }
            }
          });
      });
    });
  };

  const initHeroParallax = function () {
    if (document.documentElement.getAttribute('data-ag-reduced-motion') === 'true') return;
    const heroes = document.querySelectorAll('.ag-home-hero__video, .ag-about-hero__video, .ag-collection-hero__img, .ag-home-hero__image');
    if (!heroes.length) return;

    // Cache parent geometry to avoid getBoundingClientRect in scroll handler
    const heroData = [];
    heroes.forEach(function (hero) {
      const parent = hero.parentElement;
      if (!parent) return;
      const rect = parent.getBoundingClientRect();
      heroData.push({
        el: hero,
        parentTop: rect.top + (window.scrollY || 0),
        parentHeight: rect.height
      });
    });

    const updateCache = function () {
      viewportHeight = window.innerHeight;
      heroData.forEach(function (item) {
        const parent = item.el.parentElement;
        if (!parent) return;
        const rect = parent.getBoundingClientRect();
        item.parentTop = rect.top + (window.scrollY || 0);
        item.parentHeight = rect.height;
      });
    };

    window.addEventListener('resize', updateCache, { passive: true });
    cleanupListeners.push(function () {
      window.removeEventListener('resize', updateCache);
    });

    let ticking = false;
    let viewportHeight = window.innerHeight;

    const updateParallax = function () {
      const scrollY = window.scrollY;
      heroData.forEach(function (item) {
        var viewTop = item.parentTop - scrollY;
        var viewBottom = viewTop + item.parentHeight;
        // Only update if the hero is in or near the viewport
        if (viewTop < viewportHeight && viewBottom > 0) {
          const speed = 0.15; // Adjustment speed
          // Calculate zoom based on scroll. Start at 1.05 for a slight initial zoom
          const zoom = 1.05 + (scrollY * speed / 1000);
          item.el.style.setProperty('--hero-zoom', zoom);
        }
      });
      ticking = false;
    };

    const parallaxScrollHandler = function () {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    };

    window.addEventListener('scroll', parallaxScrollHandler, { passive: true });
    cleanupListeners.push(function () {
      window.removeEventListener('scroll', parallaxScrollHandler);
    });

    // Initial call to set state
    updateParallax();
  };

  const initImportedArticleHeroFallback = function () {
    if (!document.body.classList.contains('template-article')) return;

    const shell = document.querySelector('.ag-imported-article-shell');
    const existingShellHero = document.querySelector('.ag-imported-article-shell > .ag-imported-hero, .ag-imported-hero--fallback');
    const existingShellFeatured = document.querySelector('.ag-imported-article-shell > .ag-imported-featured-image');
    const isTypesOrganicRice = window.location.pathname === '/blogs/news/types-of-organic-rice';
    const isBiodiversityOrganicFarming = window.location.pathname === '/blogs/news/biodiversity-in-organic-farming-systems';
    const isSustainableRiceFarming = window.location.pathname === '/blogs/news/sustainable-rice-farming';

    const articleRoot = document.querySelector('.agriko-imported-article');
    if (isTypesOrganicRice || isBiodiversityOrganicFarming) {
      document.querySelectorAll('[data-imported-article-shell] h1.ag-sr-only, .ag-bio-journal h1.ag-sr-only').forEach((node) => {
        node.remove();
      });
    }
    if (!articleRoot) return;

    if (isTypesOrganicRice && !document.getElementById('ag-types-organic-rice-runtime-layout')) {
      const style = document.createElement('style');
      style.id = 'ag-types-organic-rice-runtime-layout';
      style.textContent = `
        body.template-article .ag-imported-article-shell .ag-imported-card-grid,
        body.template-article .ag-imported-article-shell .ag-imported-emphasis,
        body.template-article .ag-imported-article-shell .ag-imported-table-wrap,
        body.template-article .ag-imported-article-shell .ag-imported-cta {
          margin-left: auto !important;
          margin-right: auto !important;
        }
      `;
      document.head.appendChild(style);
    }

    if (isSustainableRiceFarming && !document.getElementById('ag-sustainable-rice-runtime-layout')) {
      const style = document.createElement('style');
      style.id = 'ag-sustainable-rice-runtime-layout';
      style.textContent = `
        body.template-article .ag-native-article-inner {
          max-width: 92rem !important;
          padding-left: clamp(1rem, 2.4vw, 2rem) !important;
          padding-right: clamp(1rem, 2.4vw, 2rem) !important;
        }
        body.template-article .ag-imported-article-shell,
        body.template-article .ag-imported-article-shell .agriko-imported-article {
          width: 100% !important;
          max-width: none !important;
        }
        body.template-article .ag-imported-article-shell > .agriko-imported-article {
          width: min(100%, 1280px) !important;
          margin-left: auto !important;
          margin-right: auto !important;
        }
      `;
      document.head.appendChild(style);
    }

    if (isTypesOrganicRice && shell) {
      Array.from(shell.children).forEach((node) => {
        if (
          node.classList &&
          (node.classList.contains('ag-imported-hero--fallback') || node.classList.contains('ag-imported-featured-image'))
        ) {
          node.remove();
        }
      });
    }

    if (articleRoot.querySelector('.ag-imported-hero')) return;

    const hasImportedStructure = articleRoot.querySelector('.ag-imported-card-grid, .ag-imported-stats, .ag-imported-emphasis, .ag-imported-table-wrap, .ag-imported-steps');
    if (!hasImportedStructure) return;

    const titleText = (document.title || '').replace(/\s*\|\s*Agriko\s*$/, '').trim();
    if (!titleText) return;

    articleRoot.querySelectorAll('.ag-sr-only').forEach((node) => {
      if (node.tagName === 'H1') node.remove();
    });

    const hero = document.createElement('section');
    hero.className = 'ag-imported-hero ag-imported-hero--runtime';

    const kicker = document.createElement('p');
    kicker.className = 'ag-imported-hero__tag';
    kicker.textContent = 'Wellness and Farm Journal';
    hero.appendChild(kicker);

    const title = document.createElement('h1');
    title.className = 'ag-imported-hero__title';
    title.textContent = titleText;
    hero.appendChild(title);

    const metaDescription = document.querySelector('meta[name="description"]');
    const subtitleText = metaDescription ? metaDescription.getAttribute('content') : '';
    if (subtitleText) {
      const subtitle = document.createElement('p');
      subtitle.className = 'ag-imported-hero__subtitle';
      subtitle.textContent = subtitleText.trim();
      hero.appendChild(subtitle);
    }

    const existingFeatured = articleRoot.querySelector('.ag-imported-featured-image');
    let featuredFigure = existingFeatured;
    const ogImage = document.querySelector('meta[property="og:image"]');
    const ogImageAlt = document.querySelector('meta[property="og:image:alt"]');
    if (!existingFeatured && ogImage && ogImage.getAttribute('content')) {
      const figure = document.createElement('figure');
      figure.className = 'ag-imported-featured-image ag-imported-featured-image--runtime';
      const img = document.createElement('img');
      img.src = ogImage.getAttribute('content');
      img.alt = (ogImageAlt && ogImageAlt.getAttribute('content')) || titleText;
      img.loading = 'eager';
      figure.appendChild(img);
      articleRoot.insertBefore(figure, articleRoot.firstChild);
      featuredFigure = figure;
    }

    if (isTypesOrganicRice && featuredFigure) {
      featuredFigure.classList.add('ag-imported-featured-image--with-overlay');
      hero.classList.add('ag-imported-hero--over-image');
      featuredFigure.appendChild(hero);
    } else {
      articleRoot.insertBefore(hero, articleRoot.querySelector('.ag-imported-featured-image') ? articleRoot.children[1] : articleRoot.firstChild);
    }

    if (existingShellHero) {
      existingShellHero.remove();
    }

    if (existingShellFeatured) {
      existingShellFeatured.remove();
    }
  };

  const normalizePerfectRiceHeroMarkup = function () {
    if (!document.body.classList.contains('template-article')) return;

    const fig = document.querySelector('.ag-imported-featured-image--cooking-perfect-rice');
    if (!fig) return;

    // If the imported HTML includes an overlaid hero <section> inside the <figure>,
    // convert it into a semantic figcaption (and ensure we don't have duplicates elsewhere).
    const overlaid = fig.querySelector(':scope > section.ag-imported-hero--overlaid');
    if (overlaid) {
      const cap = document.createElement('figcaption');
      cap.className = 'ag-imported-hero ag-imported-hero--in-figure';
      cap.setAttribute('aria-label', 'Article title');
      cap.innerHTML = overlaid.innerHTML;
      overlaid.replaceWith(cap);
    }

    // Remove any remaining overlaid hero blocks outside the figure to avoid double titles.
    document.querySelectorAll('section.ag-imported-hero--overlaid').forEach((node) => {
      if (!fig.contains(node)) node.remove();
    });
  };

  const initArticleRouteRecovery = function () {
    if (!document.body.classList.contains('template-article')) return;

    const context = window.agArticleRouteContext || {};
    const pathname = window.location.pathname;
    const isRiceStorageArticle = pathname === '/blogs/news/how-to-store-rice';

    if (isRiceStorageArticle && !document.getElementById('ag-rice-storage-opaque-text')) {
      const style = document.createElement('style');
      style.id = 'ag-rice-storage-opaque-text';
      style.textContent = `
        body.template-article .ag-rice-odyssey,
        body.template-article .ag-rice-odyssey p,
        body.template-article .ag-rice-odyssey span,
        body.template-article .ag-rice-odyssey small,
        body.template-article .ag-rice-odyssey figcaption,
        body.template-article .ag-rice-odyssey li,
        body.template-article .ag-rice-odyssey h1,
        body.template-article .ag-rice-odyssey h2,
        body.template-article .ag-rice-odyssey h3,
        body.template-article .ag-rice-odyssey strong,
        body.template-article .ag-rice-odyssey blockquote {
          color: var(--rice-ink, oklch(0.24 0.022 80)) !important;
          opacity: 1 !important;
          -webkit-text-fill-color: currentColor !important;
          background-clip: border-box !important;
          -webkit-background-clip: border-box !important;
        }

        body.template-article .ag-rice-odyssey {
          padding-top: 0 !important;
        }

        body.template-article .ag-rice-odyssey .ag-rice-kicker,
        body.template-article .ag-rice-odyssey .ag-rice-lede,
        body.template-article .ag-rice-odyssey .ag-rice-checklist li::before {
          color: var(--rice-brown, oklch(0.31 0.043 62)) !important;
        }

        body.template-article .ag-rice-odyssey__hero-copy,
        body.template-article .ag-rice-odyssey__hero-copy *,
        body.template-article .ag-rice-enemy,
        body.template-article .ag-rice-enemy *,
        body.template-article .ag-rice-wisdom,
        body.template-article .ag-rice-wisdom *,
        body.template-article .ag-rice-journal,
        body.template-article .ag-rice-journal * {
          color: oklch(0.97 0.018 86) !important;
          opacity: 1 !important;
        }

        body.template-article .ag-rice-odyssey .ag-rice-residences p,
        body.template-article .ag-rice-odyssey .ag-rice-residences small,
        body.template-article .ag-rice-odyssey .ag-rice-editions span,
        body.template-article .ag-rice-odyssey .ag-rice-future-grid p,
        body.template-article .ag-rice-odyssey .ag-rice-before-after p,
        body.template-article .ag-rice-odyssey .ag-rice-checklist span {
          color: oklch(0.3 0.027 78) !important;
          opacity: 1 !important;
        }

        body.template-article .ag-rice-odyssey :is(.ag-rice-opening, .ag-rice-enemy, .ag-rice-secret, .ag-rice-residences article, .ag-rice-editions article, .ag-rice-wisdom, .ag-rice-checklist li) {
          opacity: 1 !important;
        }

      `;
      document.head.appendChild(style);
    }

    if (isRiceStorageArticle) {
      const riceStylesheets = Array.from(document.querySelectorAll('link[href*="how-to-store-rice-recovery.css"]'));
      riceStylesheets.slice(1).forEach((link) => link.remove());
    }

    if (isRiceStorageArticle && !document.querySelector('link[href*="how-to-store-rice-recovery.css"]')) {
      const themeScript = Array.from(document.scripts).find((script) => script.src && script.src.includes('/assets/theme.js'));
      let stylesheetHref = context.riceStorageStylesheet;

      if (!stylesheetHref && themeScript) {
        const stylesheetUrl = new URL(themeScript.src, window.location.origin);
        stylesheetUrl.pathname = stylesheetUrl.pathname.replace('/theme.js', '/how-to-store-rice-recovery.css');
        stylesheetUrl.search = '';
        stylesheetHref = stylesheetUrl.toString();
      }

      if (stylesheetHref) {
        const stylesheetUrl = new URL(stylesheetHref, window.location.origin);
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = stylesheetUrl.toString();
        link.dataset.agRiceStorageRuntimeCss = 'true';
        document.head.appendChild(link);
      }
    }

    if (context.handle && context.handle.includes('how-to-store-rice') && context.riceStorageFallback) {
      document.querySelectorAll('img[src*="illust-rice-storage"], img[srcset*="illust-rice-storage"]').forEach((img) => {
        img.setAttribute('src', context.riceStorageFallback);
        img.setAttribute('srcset', context.riceStorageFallback);
        img.removeAttribute('sizes');
      });
    }

    if (isRiceStorageArticle && !document.querySelector('.ag-rice-odyssey') && document.querySelector('.ag-rice-hero')) {
      const host = document.querySelector('#MainContent .shopify-section');
      if (host && !host.dataset.riceStorageRuntimeSwap) {
        host.dataset.riceStorageRuntimeSwap = 'loading';

        fetch(`${pathname}?view=storing-rice-freshness-v2&runtime=rice-storage`, {
          credentials: 'same-origin'
        })
          .then((response) => {
            if (!response.ok) throw new Error(`Rice storage recovery failed: ${response.status}`);
            return response.text();
          })
          .then((html) => {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const article = parsed.querySelector('.ag-rice-odyssey');
            const editorialCss = parsed.querySelector('link[href*="editorial-clean.css"]');
            const riceStorageCss = parsed.querySelector('link[href*="how-to-store-rice-recovery.css"]');
            const routeCss = riceStorageCss || (context.riceStorageStylesheet ? (() => {
              const link = document.createElement('link');
              link.rel = 'stylesheet';
              link.href = context.riceStorageStylesheet;
              return link;
            })() : null);
            if (!article) throw new Error('Rice storage recovery markup missing');

            host.innerHTML = `${editorialCss ? editorialCss.outerHTML : ''}${routeCss ? routeCss.outerHTML : ''}${article.outerHTML}`;
            host.dataset.riceStorageRuntimeSwap = 'done';
            document.body.dataset.riceStorageRuntime = 'done';
          })
          .catch(() => {
            host.dataset.riceStorageRuntimeSwap = 'failed';
          });
      }
    }

    if (pathname === '/blogs/news/types-of-organic-rice' && document.body.innerText.includes('Could not find asset snippets/article-types-of-organic-rice.liquid')) {
      const host = document.querySelector('#MainContent .shopify-section');
      if (!host) return;

      host.innerHTML = `
        <div class="ag-imported-article-shell" data-imported-article-shell data-imported-parity-version="20260603-types-rice-recovery">
          <article class="agriko-imported-article">
            <section class="ag-imported-hero">
              <p class="ag-imported-hero__tag">Mindanao Grain Guide</p>
              <h1 class="ag-imported-hero__title">Types of Organic Rice</h1>
              <p class="ag-imported-hero__subtitle">A practical field guide to black, red, brown, and white rice, how they differ, and where each one belongs in a Filipino kitchen.</p>
            </section>
            <section class="ag-imported-emphasis">
              <p class="ag-imported-paragraph">Organic rice is not one product. Grain color, bran retention, aroma, cooking time, and nutrient density all change how a rice behaves on the stove and on the plate.</p>
            </section>
            <section class="ag-imported-card-grid">
              <article class="ag-imported-card">
                <h2 class="ag-imported-card__eyebrow">Black Rice</h2>
                <p class="ag-imported-card__text">The most intense option: earthy, slightly sweet, rich in anthocyanins, and best when you want a centerpiece grain.</p>
              </article>
              <article class="ag-imported-card">
                <h2 class="ag-imported-card__eyebrow">Red Rice</h2>
                <p class="ag-imported-card__text">Nutty and balanced, with more texture than white rice and an easier transition for households moving toward whole grains.</p>
              </article>
              <article class="ag-imported-card">
                <h2 class="ag-imported-card__eyebrow">Brown Rice</h2>
                <p class="ag-imported-card__text">The everyday whole-grain staple. More fiber than polished rice, a gentler glycemic profile, and a familiar flavor.</p>
              </article>
              <article class="ag-imported-card">
                <h2 class="ag-imported-card__eyebrow">White Rice</h2>
                <p class="ag-imported-card__text">The fastest-cooking and softest option. Best for speed, but with less fiber and micronutrient density than bran-on grains.</p>
              </article>
            </section>
            <section class="ag-imported-table-wrap">
              <table class="ag-imported-table">
                <thead>
                  <tr><th>Type</th><th>Best Use</th><th>Texture</th><th>Cooking Note</th></tr>
                </thead>
                <tbody>
                  <tr><td>Black Rice</td><td>Feature meals, grain bowls</td><td>Firm, dramatic</td><td>Needs the longest soak or simmer</td></tr>
                  <tr><td>Red Rice</td><td>Daily meals, mixed plates</td><td>Chewy, nutty</td><td>Benefits from extra water and rest</td></tr>
                  <tr><td>Brown Rice</td><td>Everyday staple</td><td>Hearty, familiar</td><td>Cook a bit longer than white rice</td></tr>
                  <tr><td>White Rice</td><td>Quick meals, soft texture</td><td>Tender, clean</td><td>Fastest and most forgiving</td></tr>
                </tbody>
              </table>
            </section>
            <section class="ag-imported-steps">
              <article class="ag-imported-step">
                <p class="ag-imported-step__number">1</p>
                <h2 class="ag-imported-step__title">Choose by purpose</h2>
                <p class="ag-imported-step__text">Pick black or red rice when you want flavor and nutritional density. Pick brown rice for a steady everyday whole grain. Pick white rice when speed matters most.</p>
              </article>
              <article class="ag-imported-step">
                <p class="ag-imported-step__number">2</p>
                <h2 class="ag-imported-step__title">Store bran-on grains colder</h2>
                <p class="ag-imported-step__text">Black, red, and brown rice keep more oils in the bran. That improves nutrition, but it also means they go stale faster in warm kitchens.</p>
              </article>
              <article class="ag-imported-step">
                <p class="ag-imported-step__number">3</p>
                <h2 class="ag-imported-step__title">Cook with patience</h2>
                <p class="ag-imported-step__text">Whole grains need more water, more rest, and usually more time. Rushing them is the fastest way to get uneven texture.</p>
              </article>
            </section>
          </article>
        </div>
      `;
    }
  };

  const hardenTestimonialAvatars = function () {
  const brittleAvatarPattern = /(?:optimized\/(?:maria-sm|roberto-sm|angela-sm)\.webp|about-(?:maria|founder|ana)\.png|testi\w*-(?:maria|roberto|angela)\.(?:png|jpg|jpeg|webp)|agriko-content-testimonial-(?:maria|roberto|angela)\.(?:png|jpg|jpeg|webp)|agrikoph\.com\/.+illust-(?:maria|roberto|angela))/i;
    const testimonialsRoot = document.querySelector('.ag-testimonials-section');
    const photoMap = {
      maria: testimonialsRoot?.dataset.avatarMaria || 'https://cdn.shopify.com/s/files/1/0812/7306/1602/files/agriko-content-testimonial-maria.jpg?v=1780577590',
      roberto: testimonialsRoot?.dataset.avatarRoberto || 'https://cdn.shopify.com/s/files/1/0812/7306/1602/files/agriko-content-testimonial-roberto.jpg?v=1780577590',
      angela: testimonialsRoot?.dataset.avatarAngela || 'https://cdn.shopify.com/s/files/1/0812/7306/1602/files/agriko-content-testimonial-angela.jpg?v=1780577591'
    };

    document.querySelectorAll('.testi-card__avatar').forEach((avatar, index) => {
      if (!(avatar instanceof HTMLImageElement)) return;
      const src = avatar.getAttribute('src') || '';
      const name = avatar.getAttribute('alt') || '';
      const lowerName = name.toLowerCase();
      const replacement = lowerName.includes('maria')
        ? photoMap.maria
        : lowerName.includes('roberto')
          ? photoMap.roberto
          : lowerName.includes('angela')
          ? photoMap.angela
            : '';

      avatar.loading = 'eager';
      if (!avatar.hasAttribute('fetchpriority')) {
        avatar.setAttribute('fetchpriority', index === 0 ? 'high' : 'auto');
      }

      if (replacement && brittleAvatarPattern.test(src)) {
        avatar.src = replacement;
        avatar.srcset = replacement;
      }
    });
  };

  const initProductGalleryLayout = function () {
    const galleryShell = document.querySelector('.ag-product__gallery-shell');
    if (!galleryShell) return;
    const thumbRail = galleryShell.querySelector('.ag-product__thumb-rail');
    if (!thumbRail) {
      galleryShell.classList.add('is-single-media');
    }
  };

  initArticleRouteRecovery();
  normalizeRedirectingLinks();
  initMotionPreference();
  initHeaderHeightVar();

  const bodyClasses = document.body && document.body.classList ? document.body.classList : null;
  const hasTemplateClass = function (name) {
    return Boolean(bodyClasses && bodyClasses.contains(name));
  };
  const isProductPage = hasTemplateClass('template-product');
  const isCollectionPage = hasTemplateClass('template-collection');
  const isHomePage = hasTemplateClass('template-index');

  if (isProductPage) {
    initVariantPicker();
    initProductStickyBar();
  }

  if (isCollectionPage) {
    initCollectionCardVariants();
  }

  if (isHomePage) {
    hardenHomepageMedia();
    hardenTestimonialAvatars();
  }

  initMobileMenu();
  initHeaderAutoHide();
  initCartDrawer();
  initCookieBanner();
  initRevealOnScroll();
  initFaqAccordion();
  initContactPageFaq();
  initHeroParallax();
  initImportedArticleHeroFallback();
  normalizePerfectRiceHeroMarkup();
  initArticleRouteRecovery();
  initProductGalleryLayout();

  // Initialize add to cart after DOM is ready
  if (isProductPage) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAddToCart);
    } else {
      initAddToCart();
    }
  }

  if (isProductPage) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductGalleryLayout);
    } else {
      initProductGalleryLayout();
    }
  }

  // Run weight badge fix immediately and also after DOM is fully loaded
  fixWeightBadges();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixWeightBadges);
    document.addEventListener('DOMContentLoaded', normalizeRedirectingLinks);
  }
  document.addEventListener('shopify:section:load', normalizeRedirectingLinks);

  if (isHomePage) {
    document.addEventListener('shopify:section:load', hardenHomepageMedia);
    document.addEventListener('shopify:section:load', hardenTestimonialAvatars);
  }

  if (isProductPage) {
    document.addEventListener('shopify:section:load', initProductGalleryLayout);
  }

  if (isCollectionPage) {
    document.addEventListener('shopify:section:load', initCollectionCardVariants);
  }

  window.setTimeout(normalizeRedirectingLinks, 1000);

  if (isHomePage) {
    window.setTimeout(hardenHomepageMedia, 1000);
    window.setTimeout(hardenTestimonialAvatars, 1000);
  }

  if (isProductPage) {
    window.setTimeout(initProductGalleryLayout, 1000);
  }

  if (isHomePage) {
    window.addEventListener('load', hardenHomepageMedia, { passive: true });
    window.addEventListener('load', hardenTestimonialAvatars, { passive: true });
    window.addEventListener('resize', hardenHomepageMedia, { passive: true });
  }

})();
